<template>
  <div gk-check-wrapper :class="[$style['form-check']]" :readonly="readonly" :disabled="disabled" @click.stop="handleChange" :checked="checked">
    <slot name="prev" />
    <slot name="element" :disabled="disabled" :readonly="readonly" :checked="checked">
      <div :gkcheck-color="color" gk-check :disabled="disabled" :readonly="readonly" :checked="checked">
        <template v-if="checked">
          <slot name="checked">
            <span gk-checked></span>
          </slot>
        </template>
      </div>
    </slot>
    <span v-if="label">{{label}}</span>
    <slot name="end" />
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'gkui-form-check',
  model: {
    prop: 'selected',
    event: 'change'
  },
  /**
   * @prop {String|Number|Boolean} model     选中的值
   * @prop {String|Number|Boolean} selected  radio 的值
   * @prop {String}                label     radio 的文本
   * @prop {Boolean}               disabled  是否禁用
   */
  props: {
    type: VueTypes.oneOf(['checkbox', 'radio']).def('checkbox'),
    color: VueTypes.string.def(''),
    bool: VueTypes.bool.def(false),
    value: VueTypes.oneOfType([String, Number, Boolean]).def(''),
    selected: VueTypes.oneOfType([Array, String, Number, Boolean]).def(''),
    label: VueTypes.string.def(''),
    readonly: VueTypes.bool.def(false),
    disabled: VueTypes.bool.def(false)
  },
  data () {
    return {
      currentValue: this.bool ? !!this.selected : this.selected
    }
  },
  computed: {
    checked () {
      if (this.type === 'radio' || this.bool) {
        return this.selected === this.value
      } else {
        const checked = Array.isArray(this.selected) ? this.selected : []
        return checked.indexOf(this.value) > -1
      }
    }
  },
  watch: {
    selected (value) {
      this.currentValue = value
    }
  },
  created () {
  },
  methods: {
    handleChange () {
      if (this.readOnly || this.disabled) {
        return
      }

      if (this.bool) {
        this.currentValue = !this.checked
      } else {
        if (this.type === 'radio') {
          this.currentValue = this.value
        } else {
          this.checked ? this.currentValue.splice(this.currentValue.indexOf(this.value), 1) : this.currentValue.push(this.value)
        }
      }

      this.$emit('change', this.currentValue)
    }
  }
}
</script>

<style lang="scss" module>
.form-check {
  display: flex;
  align-items: center;
  cursor: pointer;

  &[readonly],
  &[disabled] {
    cursor: not-allowed;
  }
}
</style>

